import { FileDetailsInt16Type } from "../../../components/upload/FileDetailsInt16Type";
import { FileDetailsNoFileType } from "../../../components/upload/FileDetailsNoFileType";
import { FileDetailsWavType } from "../../../components/upload/FileDetailsWavType";

const FILE_COMPONENTS = {
  WAV: FileDetailsWavType,
  INT16: FileDetailsInt16Type,
};

export const FileRenderer = ({ fileData }) => {
  const type = fileData?.fileType?.toUpperCase();
  const ComponentToRender = FILE_COMPONENTS[type] || FileDetailsNoFileType;

  return <ComponentToRender />;
};
